import Swiper from "swiper";
import setResized from './../../helpers/set-resized';
import getIndex from "../../helpers/get-index";

export default () => {

	const containers = document.querySelectorAll('.js-aside-slider');
	if (!containers.length) return;

	containers.forEach(container => {

		let slider;

		setResized(() => {

			const wrapper = container.querySelector('.js-aside-slider-wrapper');
			const slides = container.querySelectorAll('.js-aside-slider-slide');
			const startSlide = container.querySelector('.js-aside-slider-slide-current');

			console.log(slider)

			if (window.innerWidth < 1000 && !slider) {

				container.classList.add('swiper');
				wrapper.classList.add('swiper-wrapper');
				slides.forEach(item => {
					item.classList.add('swiper-slide');
				});

				slider = new Swiper(container, {
					slidesPerView: 'auto',
					spaceBetween: 16,
					initialSlide: getIndex(startSlide),
				});

			}

			else if (window.innerWidth > 999 && slider) {

				slider.destroy();
				slider = null;

				container.classList.remove('swiper');
				wrapper.classList.remove('swiper-wrapper');
				slides.forEach(item => {
					item.classList.remove('swiper-slide');
				});

			}

		});
	});

}
